module.exports = __webpack_public_path__ + "static/Footer banner short -  Green Copy-2-636e0137ec9c8d49ba68e2492e55d012.png";